import { render, staticRenderFns } from "./EditApplicantPersonalInfo.vue?vue&type=template&id=6e0f5630&scoped=true&"
import script from "./EditApplicantPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./EditApplicantPersonalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0f5630",
  null
  
)

export default component.exports